import { getRequest } from "../connection/networkInteractive";
import { InteractiveVideo } from "./../models/InteractiveVideo";

const interactiveApi = {
  videos: "interactive-videos",
  all: "/conversation/senario/all",
};

export const getInteractiveVideo = async (id, isDemo) => {
  try {
    if (isDemo) {
      // return await getInteractiveVideoDemo();
    }

    const {
      data: { data },
    } = await getRequest({
      endPoint: interactiveApi.videos,
      query: {
        senarioId: id,
      },
    });

    return data?.map((e) => InteractiveVideo.fromJSON(e));
  } catch (err) {
    console.log(err);
  }
};

export const listInteractiveService = async ({
  type,
  limit,
  page,
  scenarioId,
}) => {
  try {
    const token = localStorage.getItem("token");

    const {
      data: {
        data: {
          scenarios,
          meta: { thisPage, allPages, count },
        },
      },
    } = await getRequest({
      token,
      query: {
        type,
        limit,
        page,
        scenarioId,
      },
      endPoint: interactiveApi.all,
    });
    return {
      data: scenarios,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
      count,
    };
  } catch (error) {
    console.log("er", error);

    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
